import React, { useState, useEffect } from 'react';
import { styled } from '../../../libs/styled.es.js';

const STEP = 100;
const StyledToast = styled.div(({ showAnimation, startAnimation, animationConfig }) => `
    @keyframes slideOut {
      0% {
        transform: translateX(150%);
      }
      80% {
        transform: translateX(-20%);
      }
      100% {
        transform: translateX(0);
      }
    }
    @keyframes slideIn {
      0% {
        transform: translateX(0%);
      }
      20% {
        transform: translateX(-20%);
      }
      100% {
        transform: translateX(150%);
      }
    }
    @keyframes fadeOut {
      0% {
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
      }
      100% {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
    }
    @keyframes fadeIn {
      0% {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }
      100% {
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
      }
    }
    max-height: ${showAnimation ? '200px' : 0};
    position: relative;
    width: max-content;
    animation-duration: ${animationConfig.duration / 1000}s;
    animation-name: ${startAnimation
    ? showAnimation
        ? `${animationConfig.name}Out`
        : `${animationConfig.name}In`
    : ''};
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    opacity: ${showAnimation ? 1 : 0};
    transition: all ${animationConfig.duration / 1000}s ease-out;
  `);
const ANIMATIONS = {
    slide: {
        name: 'slide',
        duration: 400,
    },
    fade: {
        name: 'fade',
        duration: 200,
    },
};
const ToastMessage = ({ children, onRemove, countdown = 3000, animation = 'slide', }) => {
    const [timer, setTimer] = useState(countdown);
    useEffect(() => {
        const it = setInterval(() => {
            setTimer((prev) => (prev - STEP > 0 ? prev - STEP : 0));
        }, STEP);
        return () => clearInterval(it);
    }, []);
    useEffect(() => {
        if (!timer) {
            setTimeout(() => {
                onRemove();
            }, ANIMATIONS[animation].duration);
        }
    }, [onRemove, timer]);
    return (React.createElement(StyledToast, { showAnimation: timer < countdown - STEP && timer > 0, startAnimation: timer < countdown - STEP, animationConfig: ANIMATIONS[animation] }, children));
};

export { ToastMessage };
